/**
 * Redemption Gallery Filters - FIXED VERSION v6
 * 
 * Fixes:
 * 1. Uses data-video-position attribute set by Liquid (most reliable)
 * 2. Falls back to data-index if data-video-position not present
 * 3. Video visibility thresholds work correctly regardless of which videos exist
 * 4. Grid reorganization respects video positions
 */

(function() {
  'use strict';

  // ==================== CONFIGURATION ====================
  var FILTER_CONFIG = {
    filters: {
      need: {
        shopifyParam: 'filter.p.m.custom.filter_skin_concern',
        dataAttr: 'data-filter-need',
        label: 'By Need'
      },
      type: {
        shopifyParam: 'filter.p.m.custom.filter_type',
        dataAttr: 'data-filter-type',
        label: 'By Type'
      },
      ingredient: {
        shopifyParam: 'filter.p.m.custom.filter_ingredient',
        dataAttr: 'data-filter-ingredient',
        label: 'By Ingredient'
      }
    },
    sortOptions: [
      { value: 'manual', label: 'Featured' },
      { value: 'best-selling', label: 'Best Selling' },
      { value: 'created-descending', label: 'New In' },
      { value: 'price-ascending', label: 'Price, Low to High' },
      { value: 'price-descending', label: 'Price, High to Low' }
    ],
    // Video position thresholds
    // Video 1: Always shows if products exist
    // Video 2: Shows after 14 products (to have enough content before it)
    // Video 3: Shows after 24 products
    videoThresholds: {
      first: 1,   // First video needs at least 1 product
      second: 14, // Second video needs 14+ products
      third: 24   // Third video needs 24+ products
    },
    // Data-index values for each video position (set by Liquid)
    videoDataIndexes: {
      first: 1,
      second: 16,
      third: 27
    }
  };

  // ==================== STATE ====================
  var state = {
    isOpen: false,
    isInitialized: false,
    filtersApplied: false,
    mutationObserver: null,
    originalOrder: [],
    
    activeFilters: {
      sort: 'manual',
      need: [],
      type: [],
      ingredient: []
    },
    
    availableFilters: {
      need: [],
      type: [],
      ingredient: []
    },
    
    currentTabType: 'collection_tab',
    currentTabIndex: 0,
    currentCollectionHandle: null,
    totalProducts: 0,
    sectionId: null,
    
    videoItems: {
      first: null,
      second: null,
      third: null
    },
    
    // Flag to prevent infinite loop during grid reorganization
    isReorganizing: false
  };

  // ==================== DOM ELEMENTS ====================
  var elements = {
    overlay: null,
    panel: null,
    closeBtn: null,
    resetBtn: null,
    applyBtn: null,
    countDisplay: null,
    filterToggle: null
  };

  // ==================== INITIALIZATION ====================
  function init() {
    elements.overlay = document.getElementById('redemption-filter-overlay');
    elements.panel = document.getElementById('redemption-filter-panel');
    elements.closeBtn = document.getElementById('redemption-filter-close');
    elements.resetBtn = document.getElementById('redemption-filter-reset');
    elements.applyBtn = document.getElementById('redemption-filter-apply');
    elements.countDisplay = document.getElementById('redemption-filter-count');
    elements.filterToggle = document.querySelector('.filter-toggle');

    if (!elements.panel) {
      console.warn('[RedemptionFilters] Filter panel not found');
      return;
    }

    var sectionEl = document.querySelector('[data-section-id]');
    state.sectionId = sectionEl ? sectionEl.getAttribute('data-section-id') : null;

    bindEvents();
    initFilterSections();
    
    var activeTab = document.querySelector('.tab-menu-link.active');
    if (activeTab) {
      state.currentTabType = activeTab.getAttribute('data-tab-type') || 'collection_tab';
      state.currentTabIndex = parseInt(activeTab.getAttribute('data-tab-index')) || 0;
      state.currentCollectionHandle = activeTab.getAttribute('data-collection-handle');
    }
    
    setTimeout(function() {
      identifyVideoItems();
      saveOriginalOrder();
      buildFiltersFromCurrentTab();
      setupMutationObserver();
    }, 500);
    
    state.isInitialized = true;
    console.log('[RedemptionFilters] Initialized. Tab type:', state.currentTabType);
  }

  // ==================== IDENTIFY VIDEO ITEMS ====================
  // PRIMARY: Uses data-video-position attribute (set by Liquid template)
  // FALLBACK: Uses data-index to determine position
  function identifyVideoItems() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid) return;
    
    var videoItems = productGrid.querySelectorAll('.grid__item.video-item');
    
    // Reset video tracking
    state.videoItems = { first: null, second: null, third: null };
    
    videoItems.forEach(function(video) {
      // PRIMARY: Use data-video-position attribute (set by Liquid template)
      var videoPosition = video.getAttribute('data-video-position');
      
      if (videoPosition === 'first') {
        state.videoItems.first = video;
        console.log('[RedemptionFilters] Identified FIRST video via data-video-position');
      } else if (videoPosition === 'second') {
        state.videoItems.second = video;
        console.log('[RedemptionFilters] Identified SECOND video via data-video-position');
      } else if (videoPosition === 'third') {
        state.videoItems.third = video;
        console.log('[RedemptionFilters] Identified THIRD video via data-video-position');
      } else {
        // FALLBACK: Use data-index to determine position
        var dataIndex = parseInt(video.getAttribute('data-index')) || 0;
        
        if (dataIndex === FILTER_CONFIG.videoDataIndexes.first) {
          if (!state.videoItems.first) {
            state.videoItems.first = video;
            video.setAttribute('data-video-position', 'first');
            console.log('[RedemptionFilters] Identified FIRST video via data-index:', dataIndex);
          } else {
            console.warn('[RedemptionFilters] Duplicate video with data-index=1 found, skipping');
          }
        } else if (dataIndex === FILTER_CONFIG.videoDataIndexes.second) {
          state.videoItems.second = video;
          video.setAttribute('data-video-position', 'second');
          console.log('[RedemptionFilters] Identified SECOND video via data-index:', dataIndex);
        } else if (dataIndex === FILTER_CONFIG.videoDataIndexes.third) {
          state.videoItems.third = video;
          video.setAttribute('data-video-position', 'third');
          console.log('[RedemptionFilters] Identified THIRD video via data-index:', dataIndex);
        } else if (dataIndex > 0) {
          console.warn('[RedemptionFilters] Video at unexpected data-index:', dataIndex);
        }
      }
    });
    
    console.log('[RedemptionFilters] Video identification complete:', {
      first: state.videoItems.first ? 'found' : 'not present',
      second: state.videoItems.second ? 'found' : 'not present',
      third: state.videoItems.third ? 'found' : 'not present'
    });
  }

  // ==================== SAVE ORIGINAL ORDER ====================
  function saveOriginalOrder() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid) return;
    
    state.originalOrder = Array.from(productGrid.querySelectorAll('.grid__item'));
    console.log('[RedemptionFilters] Saved original order:', state.originalOrder.length, 'items');
  }

  // ==================== RESTORE ORIGINAL ORDER ====================
  function restoreOriginalOrder() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid || state.originalOrder.length === 0) return;
    
    // Disconnect MutationObserver before DOM manipulation
    if (state.mutationObserver) {
      state.mutationObserver.disconnect();
    }
    
    var fragment = document.createDocumentFragment();
    
    state.originalOrder.forEach(function(item) {
      item.style.removeProperty('order');
      fragment.appendChild(item);
    });
    
    productGrid.innerHTML = '';
    productGrid.appendChild(fragment);
    
    // Remove the grid-auto-flow override when filters are cleared
    productGrid.style.removeProperty('grid-auto-flow');
    
    console.log('[RedemptionFilters] Restored original order');
    
    // Reconnect MutationObserver
    setTimeout(function() {
      setupMutationObserver();
    }, 200);
  }

  // ==================== MUTATION OBSERVER ====================
  function setupMutationObserver() {
    if (state.mutationObserver) {
      state.mutationObserver.disconnect();
    }
    
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid) return;
    
    state.mutationObserver = new MutationObserver(function(mutations) {
      var newProductsAdded = false;
      var newVideosAdded = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.classList && node.classList.contains('grid__item')) {
              newProductsAdded = true;
              
              if (state.originalOrder.indexOf(node) === -1) {
                state.originalOrder.push(node);
              }
              
              if (node.classList.contains('video-item')) {
                newVideosAdded = true;
              }
              
              if (state.filtersApplied && !node.classList.contains('video-item')) {
                var card = node.querySelector('.card-wrapper, .product-card-wrapper') || node;
                var shouldShow = productMatchesFilters(card);
                
                if (!shouldShow) {
                  node.style.setProperty('display', 'none', 'important');
                  node.classList.add('filtered-hidden');
                }
              }
            }
          });
        }
      });
      
      if (newVideosAdded) {
        identifyVideoItems();
      }
      
      if (newProductsAdded && state.filtersApplied) {
        console.log('[RedemptionFilters] New products added from infinite scroll, re-applying filters');
        setTimeout(function() {
          applyVideoVisibility();
          reorganizeGrid();
          fixGridBorders();
          updateProductCount();
        }, 50);
      }
    });
    
    state.mutationObserver.observe(productGrid, {
      childList: true,
      subtree: false
    });
    
    console.log('[RedemptionFilters] MutationObserver set up for product grid');
  }

  // ==================== APPLY VIDEO VISIBILITY ====================
  function applyVideoVisibility() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid) return;
    
    var allItems = productGrid.querySelectorAll('.grid__item');
    var visibleProductCount = 0;
    
    allItems.forEach(function(item) {
      if (!item.classList.contains('video-item') && 
          !item.classList.contains('filtered-hidden') &&
          item.style.display !== 'none') {
        visibleProductCount++;
      }
    });
    
    var isMobile = window.innerWidth < 768;
    
    // Different thresholds for mobile vs desktop
    var thresholds = isMobile ? {
      first: 1,   // First video needs at least 1 product
      second: 8,  // Second video needs 8+ products (mobile layout)
      third: 16   // Third video needs 16+ products (mobile layout)
    } : FILTER_CONFIG.videoThresholds;
    
    console.log('[RedemptionFilters] Visible products for video logic:', visibleProductCount, 'isMobile:', isMobile);
    
    if (state.videoItems.first) {
      if (visibleProductCount >= thresholds.first) {
        showVideo(state.videoItems.first, 'first');
      } else {
        hideVideo(state.videoItems.first, 'first');
      }
    }
    
    if (state.videoItems.second) {
      if (visibleProductCount >= thresholds.second) {
        showVideo(state.videoItems.second, 'second');
      } else {
        hideVideo(state.videoItems.second, 'second');
      }
    }
    
    if (state.videoItems.third) {
      if (visibleProductCount >= thresholds.third) {
        showVideo(state.videoItems.third, 'third');
      } else {
        hideVideo(state.videoItems.third, 'third');
      }
    }
  }

  // ==================== SHOW/HIDE VIDEO HELPERS ====================
  function showVideo(videoElement, position) {
    if (!videoElement) return;
    
    videoElement.style.display = '';
    videoElement.style.removeProperty('display');
    videoElement.classList.remove('filtered-hidden');
    videoElement.classList.remove('video-hidden');
    console.log('[RedemptionFilters] ' + position + ' video: VISIBLE');
  }

  function hideVideo(videoElement, position) {
    if (!videoElement) return;
    
    videoElement.style.setProperty('display', 'none', 'important');
    videoElement.classList.add('filtered-hidden');
    videoElement.classList.add('video-hidden');
    console.log('[RedemptionFilters] ' + position + ' video: HIDDEN');
  }

  // ==================== REORGANIZE GRID ====================
  function reorganizeGrid() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid) return;
    
    // CRITICAL: Disconnect MutationObserver before DOM manipulation
    if (state.mutationObserver) {
      state.mutationObserver.disconnect();
    }
    
    var isMobile = window.innerWidth < 768;
    
    var allItems = Array.from(productGrid.querySelectorAll('.grid__item'));
    
    var visibleFirstVideo = null;
    var visibleSecondVideo = null;
    var visibleThirdVideo = null;
    var visibleProducts = [];
    var hiddenItems = [];
    
    allItems.forEach(function(item) {
      // Remove any previous positioning
      item.style.removeProperty('order');
      item.style.removeProperty('grid-row');
      item.style.removeProperty('grid-column');
      
      if (item.classList.contains('video-item')) {
        var videoPosition = item.getAttribute('data-video-position');
        var isHidden = item.classList.contains('filtered-hidden') || 
                       item.classList.contains('video-hidden') ||
                       item.style.display === 'none';
        
        if (isHidden) {
          hiddenItems.push(item);
        } else if (videoPosition === 'first') {
          visibleFirstVideo = item;
        } else if (videoPosition === 'second') {
          visibleSecondVideo = item;
        } else if (videoPosition === 'third') {
          visibleThirdVideo = item;
        } else {
          hiddenItems.push(item);
        }
      } else if (item.classList.contains('filtered-hidden') || item.style.display === 'none') {
        hiddenItems.push(item);
      } else {
        visibleProducts.push(item);
      }
    });
    
    var totalVisibleProducts = visibleProducts.length;
    
    console.log('[RedemptionFilters] Reorganizing grid:', {
      visibleFirstVideo: !!visibleFirstVideo,
      visibleSecondVideo: !!visibleSecondVideo,
      visibleThirdVideo: !!visibleThirdVideo,
      visibleProducts: totalVisibleProducts,
      hiddenItems: hiddenItems.length,
      isMobile: isMobile
    });
    
    // Build the final ordered array - DOM order determines grid position
    var finalOrder = [];
    
    if (isMobile) {
      // MOBILE LAYOUT: 2 columns, all videos span full width
      // Products: 2 per row, Videos: full width (2 cols) x 2 rows
      // Simpler layout - videos just need enough products before them
      
      // Video 1 first
      if (visibleFirstVideo) {
        finalOrder.push(visibleFirstVideo);
      }
      
      // Products before video 2: 4 products (with video 1 taking 2 rows = 4 product spaces)
      // Then 2 more full rows = 4 products, so 8 products total before video 2
      var productsBeforeSecondVideo = visibleProducts.slice(0, 8);
      finalOrder = finalOrder.concat(productsBeforeSecondVideo);
      
      // Video 2
      if (visibleSecondVideo) {
        finalOrder.push(visibleSecondVideo);
      }
      
      // Products between video 2 and 3: 8 products
      var productsBetweenVideos = visibleProducts.slice(8, 16);
      finalOrder = finalOrder.concat(productsBetweenVideos);
      
      // Video 3
      if (visibleThirdVideo) {
        finalOrder.push(visibleThirdVideo);
      }
      
      // Remaining products
      var remainingProducts = visibleProducts.slice(16);
      finalOrder = finalOrder.concat(remainingProducts);
      
    } else {
      // DESKTOP LAYOUT: 4 columns with alternating video positions
      
      // Position 1: First video (if visible) - LEFT side (cols 1-2)
      if (visibleFirstVideo) {
        finalOrder.push(visibleFirstVideo);
      }
      
      // GRID LAYOUT MATH for 4-column grid with alternating 2x2 videos:
      // Video 1 (LEFT): cols 1-2, rows 1-2. Products fill cols 3-4 (4 products for 2 rows)
      // Then full rows of 4 products each.
      // Video 2 (RIGHT): cols 3-4. Need 2 products before it in that row to push it right.
      // Video 3 (LEFT): cols 1-2. Need row to start fresh.
      
      // After video 1: 4 products fill cols 3-4 of rows 1-2
      // Then we need products to fill rows until video 2
      // Video 2 should appear after 14 products (4 + 4 + 4 + 2 = 14)
      // The last 2 products push video 2 to the right side
      var productsBeforeSecondVideo = visibleProducts.slice(0, 14);
      finalOrder = finalOrder.concat(productsBeforeSecondVideo);
      
      // Position 16: Second video (if visible) - RIGHT side (cols 3-4)
      if (visibleSecondVideo) {
        finalOrder.push(visibleSecondVideo);
      }
      
      // After video 2: products fill around it, then full rows until video 3
      var productsBetweenVideos = visibleProducts.slice(14, 24);
      finalOrder = finalOrder.concat(productsBetweenVideos);
      
      // Position 27: Third video (if visible) - LEFT side (cols 1-2)
      if (visibleThirdVideo) {
        finalOrder.push(visibleThirdVideo);
      }
      
      // Remaining products (after video 3)
      var remainingProducts = visibleProducts.slice(24);
      finalOrder = finalOrder.concat(remainingProducts);
    }
    
    // Hidden items at the end
    finalOrder = finalOrder.concat(hiddenItems);
    
    // Create a document fragment for efficient DOM manipulation
    var fragment = document.createDocumentFragment();
    
    finalOrder.forEach(function(item) {
      fragment.appendChild(item);
    });
    
    // Clear grid and append fragment (single DOM operation)
    productGrid.innerHTML = '';
    productGrid.appendChild(fragment);
    
    productGrid.classList.add('filters-active');
    
    // CRITICAL: Force grid to respect DOM order by setting grid-auto-flow: row
    // This prevents CSS Grid from reordering spanning items
    productGrid.style.setProperty('grid-auto-flow', 'row', 'important');
    
    console.log('[RedemptionFilters] Grid reorganized with', finalOrder.length, 'items');
    
    // Reconnect MutationObserver after a delay
    setTimeout(function() {
      setupMutationObserver();
    }, 200);
  }

  // ==================== FIX GRID BORDERS ====================
  function fixGridBorders() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productGrid = activePanel.querySelector('#product-grid');
    if (!productGrid) return;
    
    var allItems = productGrid.querySelectorAll('.grid__item');
    
    // First, remove all previous border styles
    allItems.forEach(function(item) {
      item.style.removeProperty('border-right');
      item.classList.remove('filter-row-end');
      item.classList.remove('filter-row-start');
      item.classList.remove('filter-row-end-mobile');
    });
    
    if (!state.filtersApplied) return;
    
    var visibleItems = Array.from(allItems).filter(function(item) {
      return !item.classList.contains('filtered-hidden') && 
             !item.classList.contains('video-hidden') &&
             item.style.display !== 'none';
    });
    
    if (visibleItems.length === 0) return;
    
    var isMobile = window.innerWidth < 768;
    var columns = isMobile ? 2 : 4;
    
    // Check if there are any visible videos
    var visibleVideos = visibleItems.filter(function(item) {
      return item.classList.contains('video-item');
    });
    
    var hasVideos = visibleVideos.length > 0;
    
    console.log('[RedemptionFilters] Border calculation - hasVideos:', hasVideos, 'isMobile:', isMobile, 'columns:', columns);
    
    if (!hasVideos) {
      // NO VIDEOS: Simple grid calculation
      var productIndex = 0;
      visibleItems.forEach(function(item) {
        var col = (productIndex % columns) + 1;
        
        if (col === columns) {
          item.style.setProperty('border-right', 'none', 'important');
          item.classList.add('filter-row-end');
        } else {
          item.style.setProperty('border-right', '0.5px solid var(--color-secondary)', 'important');
        }
        
        if (col === 1) {
          item.classList.add('filter-row-start');
        }
        
        productIndex++;
      });
      console.log('[RedemptionFilters] Fixed borders (no videos) for ' + visibleItems.length + ' items');
      return;
    }
    
    // HAS VIDEOS: Simulate grid placement
    // Desktop: 4 columns, Video 1&3 at cols 1-2 (LEFT), Video 2 at cols 3-4 (RIGHT)
    // Mobile: 2 columns, ALL videos span full width (cols 1-2)
    
    var grid = {};
    var maxRow = 1;
    
    function isOccupied(row, col) {
      return grid[row + '-' + col] === true;
    }
    
    function occupy(row, col) {
      grid[row + '-' + col] = true;
      if (row > maxRow) maxRow = row;
    }
    
    function findNextFreePosition() {
      for (var r = 1; r <= maxRow + 10; r++) {
        for (var c = 1; c <= columns; c++) {
          if (!isOccupied(r, c)) {
            return { row: r, col: c };
          }
        }
      }
      return { row: maxRow + 1, col: 1 };
    }
    
    var itemPositions = [];
    
    visibleItems.forEach(function(item) {
      var isVideo = item.classList.contains('video-item');
      var videoPosition = item.getAttribute('data-video-position');
      
      if (isVideo) {
        var videoCol;
        var videoColSpan;
        
        if (isMobile) {
          // MOBILE: All videos span full width (columns 1-2)
          videoCol = 1;
          videoColSpan = 2;
        } else {
          // DESKTOP: Video position determines column
          videoCol = (videoPosition === 'first' || videoPosition === 'third') ? 1 : 3;
          videoColSpan = 2;
        }
        
        // Find row where video's space is free
        var videoRow = 1;
        var isFree = false;
        while (!isFree) {
          isFree = true;
          for (var c = videoCol; c < videoCol + videoColSpan; c++) {
            if (isOccupied(videoRow, c) || isOccupied(videoRow + 1, c)) {
              isFree = false;
              break;
            }
          }
          if (!isFree) videoRow++;
        }
        
        // Occupy the 2x2 space
        for (var c = videoCol; c < videoCol + videoColSpan; c++) {
          occupy(videoRow, c);
          occupy(videoRow + 1, c);
        }
        
        itemPositions.push({
          element: item,
          isVideo: true,
          row: videoRow,
          col: videoCol,
          endCol: videoCol + videoColSpan - 1,
          endRow: videoRow + 1,
          videoPosition: videoPosition
        });
      } else {
        // Product: find next free 1x1 cell
        var pos = findNextFreePosition();
        occupy(pos.row, pos.col);
        
        itemPositions.push({
          element: item,
          isVideo: false,
          row: pos.row,
          col: pos.col
        });
      }
    });
    
    // Apply borders based on calculated positions
    itemPositions.forEach(function(pos) {
      var item = pos.element;
      
      if (pos.isVideo) {
        // Videos never have right border
        item.style.setProperty('border-right', 'none', 'important');
        item.classList.add('filter-row-end');
        return;
      }
      
      // Check if there's a video immediately to the right
      var hasVideoToRight = false;
      
      if (!isMobile) {
        // Only check on desktop (on mobile, videos are full width)
        itemPositions.forEach(function(otherPos) {
          if (otherPos.isVideo) {
            if (otherPos.col === pos.col + 1) {
              if (pos.row >= otherPos.row && pos.row <= otherPos.endRow) {
                hasVideoToRight = true;
              }
            }
          }
        });
      }
      
      // Apply border
      if (pos.col === columns) {
        item.style.setProperty('border-right', 'none', 'important');
        item.classList.add('filter-row-end');
        if (isMobile) item.classList.add('filter-row-end-mobile');
      } else if (hasVideoToRight) {
        item.style.setProperty('border-right', 'none', 'important');
        item.classList.add('filter-row-end');
      } else {
        item.style.setProperty('border-right', '0.5px solid var(--color-secondary)', 'important');
      }
      
      if (pos.col === 1) {
        item.classList.add('filter-row-start');
      }
    });
    
    console.log('[RedemptionFilters] Fixed borders (with videos) for ' + visibleItems.length + ' items');
  }

  var resizeTimeout;
  window.addEventListener('resize', function() {
    if (!state.filtersApplied) return;
    
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      fixGridBorders();
    }, 100);
  });

  // ==================== BUILD FILTERS FROM CURRENT TAB ====================
  function buildFiltersFromCurrentTab(retryCount) {
    retryCount = retryCount || 0;
    
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var productCards = activePanel.querySelectorAll('.grid__item:not(.video-item) .card-wrapper, .grid__item:not(.video-item) .product-card-wrapper');
    
    if (productCards.length === 0) {
      productCards = activePanel.querySelectorAll('.card-wrapper[data-filter-need], .product-card-wrapper[data-filter-need]');
    }
    
    if (productCards.length === 0 && retryCount < 10) {
      setTimeout(function() { buildFiltersFromCurrentTab(retryCount + 1); }, 500);
      return;
    }
    
    var filterData = { need: {}, type: {}, ingredient: {} };
    
    productCards.forEach(function(card) {
      var cardWithData = card;
      if (!card.hasAttribute('data-filter-need') && !card.hasAttribute('data-filter-type')) {
        cardWithData = card.querySelector('[data-filter-need], [data-filter-type]') || card;
      }
      
      Object.keys(FILTER_CONFIG.filters).forEach(function(filterType) {
        var config = FILTER_CONFIG.filters[filterType];
        var attrValue = cardWithData.getAttribute(config.dataAttr);
        
        if (!attrValue || attrValue.trim() === '') return;
        
        var cleanedValue = attrValue
          .replace(/^\[|\]$/g, '')
          .replace(/"/g, '')
          .replace(/\\/g, '')
          .toLowerCase();
        
        var values = cleanedValue.split(',').map(function(v) { 
          return v.trim(); 
        }).filter(Boolean);
        
        var counted = {};
        values.forEach(function(value) {
          if (!value || counted[value]) return;
          counted[value] = true;
          
          if (!filterData[filterType][value]) {
            filterData[filterType][value] = {
              value: value,
              label: formatLabel(value),
              count: 0
            };
          }
          filterData[filterType][value].count++;
        });
      });
    });
    
    Object.keys(filterData).forEach(function(filterType) {
      state.availableFilters[filterType] = Object.values(filterData[filterType])
        .sort(function(a, b) { return a.label.localeCompare(b.label); });
    });
    
    state.totalProducts = productCards.length;
    
    console.log('[RedemptionFilters] Filters built:', {
      need: state.availableFilters.need.length,
      type: state.availableFilters.type.length,
      ingredient: state.availableFilters.ingredient.length,
      totalProducts: state.totalProducts
    });
    
    renderFilters();
    updateProductCount();
    
    if (state.originalOrder.length === 0) {
      saveOriginalOrder();
    }
    
    identifyVideoItems();
    setupMutationObserver();
  }

  // ==================== FORMAT LABEL ====================
  function formatLabel(value) {
    if (!value) return '';
    
    var label = value.split(' ').map(function(word) {
      if (word.length === 0) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join(' ');
    
    if (label.indexOf('+') > -1) {
      label = label.split('+').map(function(part) {
        return part.trim().split(' ').map(function(word) {
          if (word.length === 0) return '';
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
      }).join(' + ');
    }
    
    return label;
  }

  // ==================== EVENT BINDING ====================
  function bindEvents() {
    if (elements.filterToggle) {
      elements.filterToggle.addEventListener('click', function(e) {
        e.preventDefault();
        openPanel();
      });
    }

    document.querySelectorAll('.filter_trigger_button').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        openPanel();
      });
    });

    if (elements.closeBtn) {
      elements.closeBtn.addEventListener('click', closePanel);
    }

    if (elements.overlay) {
      elements.overlay.addEventListener('click', closePanel);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && state.isOpen) {
        closePanel();
      }
    });

    if (elements.resetBtn) {
      elements.resetBtn.addEventListener('click', resetFilters);
    }

    if (elements.applyBtn) {
      elements.applyBtn.addEventListener('click', applyFilters);
    }

    document.addEventListener('click', function(e) {
      var tabButton = e.target.closest('.tab-menu-link');
      if (tabButton) {
        var tabIndex = parseInt(tabButton.getAttribute('data-tab-index')) || 0;
        
        if (tabIndex !== state.currentTabIndex) {
          state.currentTabType = tabButton.getAttribute('data-tab-type') || 'collection_tab';
          state.currentTabIndex = tabIndex;
          state.currentCollectionHandle = tabButton.getAttribute('data-collection-handle');
          
          resetFiltersState();
          state.filtersApplied = false;
          state.originalOrder = [];
          state.videoItems = { first: null, second: null, third: null };
          updateActiveFiltersDisplay();
          
          if (state.mutationObserver) {
            state.mutationObserver.disconnect();
          }
          
          setTimeout(function() {
            identifyVideoItems();
            saveOriginalOrder();
            buildFiltersFromCurrentTab();
          }, 500);
        }
      }
    });

    elements.panel.addEventListener('change', function(e) {
      var checkbox = e.target.closest('input[type="checkbox"]');
      var radio = e.target.closest('input[type="radio"]');
      
      if (checkbox) {
        handleCheckboxChange(checkbox);
      } else if (radio) {
        handleSortChange(radio);
      }
    });
  }

  // ==================== PANEL CONTROLS ====================
  function openPanel() {
    state.isOpen = true;
    elements.panel.classList.add('active');
    elements.overlay.classList.add('active');
    document.body.classList.add('redemption-filter-open');
    elements.panel.setAttribute('aria-hidden', 'false');
    updateProductCount();
  }

  function closePanel() {
    state.isOpen = false;
    elements.panel.classList.remove('active');
    elements.overlay.classList.remove('active');
    document.body.classList.remove('redemption-filter-open');
    elements.panel.setAttribute('aria-hidden', 'true');
  }

  // ==================== ACCORDION ====================
  function initFilterSections() {
    var toggleButtons = elements.panel.querySelectorAll('[data-filter-toggle]');
    
    toggleButtons.forEach(function(button) {
      button.addEventListener('click', function() {
        var filterType = button.getAttribute('data-filter-toggle');
        var content = elements.panel.querySelector('[data-filter-content="' + filterType + '"]');
        var isExpanded = button.getAttribute('aria-expanded') === 'true';
        
        button.setAttribute('aria-expanded', !isExpanded);
        
        if (isExpanded) {
          content.setAttribute('hidden', '');
        } else {
          content.removeAttribute('hidden');
        }
      });
    });
  }

  // ==================== RENDER FILTERS ====================
  function renderFilters() {
    Object.keys(state.availableFilters).forEach(function(filterType) {
      var list = elements.panel.querySelector('[data-filter-list="' + filterType + '"]');
      if (!list) return;
      
      var filters = state.availableFilters[filterType];
      
      if (filters.length === 0) {
        list.innerHTML = '<li class="redemption-filter-item redemption-filter-item--empty">No options available</li>';
        return;
      }
      
      var html = filters.map(function(filter) {
        var isChecked = state.activeFilters[filterType].indexOf(filter.value) > -1;
        var countHtml = filter.count > 0 ? '<span class="redemption-filter-checkbox__count">(' + filter.count + ')</span>' : '';
        
        return '<li class="redemption-filter-item">' +
          '<label class="redemption-filter-checkbox">' +
          '<input type="checkbox" name="filter-' + filterType + '" value="' + filter.value + '"' + (isChecked ? ' checked' : '') + '>' +
          '<span class="redemption-filter-checkbox__indicator"></span>' +
          '<span class="redemption-filter-checkbox__label">' + filter.label + '</span>' +
          countHtml +
          '</label>' +
          '</li>';
      }).join('');
      
      list.innerHTML = html;
    });
  }

  // ==================== HANDLE FILTER CHANGES ====================
  function handleCheckboxChange(checkbox) {
    var filterType = checkbox.name.replace('filter-', '');
    var value = checkbox.value;
    
    if (checkbox.checked) {
      if (state.activeFilters[filterType].indexOf(value) === -1) {
        state.activeFilters[filterType].push(value);
      }
    } else {
      var index = state.activeFilters[filterType].indexOf(value);
      if (index > -1) {
        state.activeFilters[filterType].splice(index, 1);
      }
    }
    
    updateProductCount();
  }

  function handleSortChange(radio) {
    state.activeFilters.sort = radio.value;
  }

  // ==================== UPDATE PRODUCT COUNT ====================
  function updateProductCount() {
    var count = countMatchingProducts();
    if (elements.countDisplay) {
      elements.countDisplay.textContent = count;
    }
  }

  function countMatchingProducts() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return 0;
    
    var gridItems = activePanel.querySelectorAll('#product-grid > .grid__item:not(.video-item)');
    
    var hasActiveFilters = Object.keys(FILTER_CONFIG.filters).some(function(filterType) {
      return state.activeFilters[filterType].length > 0;
    });
    
    if (!hasActiveFilters) {
      return gridItems.length;
    }
    
    var matchingCount = 0;
    gridItems.forEach(function(gridItem) {
      var card = gridItem.querySelector('.card-wrapper, .product-card-wrapper') || gridItem;
      if (productMatchesFilters(card)) {
        matchingCount++;
      }
    });
    
    return matchingCount;
  }

  // ==================== PRODUCT MATCHING ====================
  function productMatchesFilters(card) {
    var hasActiveFilters = false;
    var allTypesMatch = true;
    
    Object.keys(FILTER_CONFIG.filters).forEach(function(filterType) {
      var activeValues = state.activeFilters[filterType];
      if (activeValues.length === 0) return;
      
      hasActiveFilters = true;
      var config = FILTER_CONFIG.filters[filterType];
      
      var attrValue = card.getAttribute(config.dataAttr);
      if (!attrValue) {
        var childCard = card.querySelector('[' + config.dataAttr + ']');
        if (childCard) {
          attrValue = childCard.getAttribute(config.dataAttr);
        }
      }
      
      if (!attrValue || attrValue.trim() === '') {
        allTypesMatch = false;
        return;
      }
      
      var cleanedValue = attrValue
        .replace(/^\[|\]$/g, '')
        .replace(/"/g, '')
        .replace(/\\/g, '')
        .toLowerCase()
        .trim();
      
      var productValues = cleanedValue.split(',').map(function(v) { 
        return v.trim().toLowerCase(); 
      }).filter(Boolean);
      
      var typeMatches = activeValues.some(function(activeValue) {
        var normalizedActive = activeValue.toLowerCase().trim();
        return productValues.some(function(productValue) {
          return productValue === normalizedActive || 
                 productValue.indexOf(normalizedActive) > -1 ||
                 normalizedActive.indexOf(productValue) > -1;
        });
      });
      
      if (!typeMatches) {
        allTypesMatch = false;
      }
    });
    
    if (!hasActiveFilters) {
      return true;
    }
    
    return allTypesMatch;
  }

  // ==================== RESET FILTERS ====================
  function resetFilters() {
    resetFiltersState();
    state.filtersApplied = false;
    renderFilters();
    updateProductCount();
    updateActiveFiltersDisplay();
    
    var sortRadio = elements.panel.querySelector('input[name="redemption-sort"][value="manual"]');
    if (sortRadio) {
      sortRadio.checked = true;
    }
    
    showAllProducts();
    restoreOriginalOrder();
    
    var activePanel = document.querySelector('.tab-panel.active');
    if (activePanel) {
      var productGrid = activePanel.querySelector('#product-grid');
      if (productGrid) {
        productGrid.classList.remove('filters-active');
        productGrid.style.removeProperty('grid-auto-flow');
        
        productGrid.querySelectorAll('.grid__item').forEach(function(item) {
          item.classList.remove('filter-row-end');
          item.classList.remove('filter-row-start');
          item.classList.remove('filter-row-end-mobile');
          item.classList.remove('video-hidden');
          item.style.removeProperty('border-right');
          item.style.removeProperty('order');
        });
      }
    }
    
    // Re-setup MutationObserver
    setTimeout(function() {
      setupMutationObserver();
    }, 300);

    updateMobileFilterButton();
  }

  function resetFiltersState() {
    state.activeFilters = {
      sort: 'manual',
      need: [],
      type: [],
      ingredient: []
    };
    updateMobileFilterButton();
  }

  // ==================== SHOW ALL PRODUCTS ====================
  function showAllProducts() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) return;
    
    var gridItems = activePanel.querySelectorAll('.grid__item');
    gridItems.forEach(function(item) {
      item.style.display = '';
      item.style.removeProperty('display');
      item.style.removeProperty('border-right');
      item.style.removeProperty('order');
      item.classList.remove('filtered-hidden');
      item.classList.remove('filter-row-end');
      item.classList.remove('filter-row-start');
      item.classList.remove('filter-row-end-mobile');
      item.classList.remove('video-hidden');
    });
    
    var noResults = activePanel.querySelector('.no-results-message');
    if (noResults) noResults.remove();
    
    console.log('[RedemptionFilters] Showing all products');
  }

  // ==================== APPLY FILTERS ====================
  function applyFilters() {
    console.log('[RedemptionFilters] Applying filters:', JSON.stringify(state.activeFilters));
    
    var hasActiveFilters = Object.keys(FILTER_CONFIG.filters).some(function(filterType) {
      return state.activeFilters[filterType].length > 0;
    });
    
    state.filtersApplied = hasActiveFilters;
    
    if (hasActiveFilters) {
      applyClientSideFilters();
      applyVideoVisibility();
      reorganizeGrid();
      fixGridBorders();
    } else {
      showAllProducts();
      restoreOriginalOrder();
      
      var activePanel = document.querySelector('.tab-panel.active');
      if (activePanel) {
        var productGrid = activePanel.querySelector('#product-grid');
        if (productGrid) {
          productGrid.classList.remove('filters-active');
        }
      }
    }
    
    updateActiveFiltersDisplay();
    closePanel();
    setupMutationObserver();
  }

  // ==================== CLIENT-SIDE FILTERS ====================
  function applyClientSideFilters() {
    var activePanel = document.querySelector('.tab-panel.active');
    if (!activePanel) {
      console.warn('[RedemptionFilters] No active panel found');
      return;
    }
    
    var gridItems = activePanel.querySelectorAll('#product-grid > .grid__item');
    
    console.log('[RedemptionFilters] Processing', gridItems.length, 'grid items');
    
    var hasActiveFilters = Object.keys(FILTER_CONFIG.filters).some(function(filterType) {
      return state.activeFilters[filterType].length > 0;
    });
    
    var visibleCount = 0;
    var hiddenCount = 0;
    
    gridItems.forEach(function(gridItem) {
      if (gridItem.classList.contains('video-item')) {
        return;
      }
      
      var card = gridItem.querySelector('.card-wrapper, .product-card-wrapper');
      if (!card) {
        card = gridItem;
      }
      
      var shouldShow = !hasActiveFilters || productMatchesFilters(card);
      
      if (shouldShow) {
        gridItem.style.display = '';
        gridItem.style.removeProperty('display');
        gridItem.classList.remove('filtered-hidden');
        visibleCount++;
      } else {
        gridItem.style.setProperty('display', 'none', 'important');
        gridItem.classList.add('filtered-hidden');
        hiddenCount++;
      }
    });
    
    console.log('[RedemptionFilters] Product filtering result: Visible=' + visibleCount + ', Hidden=' + hiddenCount);
    
    if (state.activeFilters.sort && state.activeFilters.sort !== 'manual') {
      sortProductsClientSide(activePanel);
    }
    
    handleNoResults(activePanel, visibleCount);
    updateProgressBar(activePanel, visibleCount);
  }

  // ==================== SORT PRODUCTS ====================
  function sortProductsClientSide(panel) {
    var grid = panel.querySelector('#product-grid, .product-grid');
    if (!grid) return;
    
    var items = Array.from(grid.querySelectorAll('.grid__item:not(.filtered-hidden):not(.video-item)'));
    
    items.sort(function(a, b) {
      var cardA = a.querySelector('.card-wrapper, .product-card-wrapper') || a;
      var cardB = b.querySelector('.card-wrapper, .product-card-wrapper') || b;
      
      switch (state.activeFilters.sort) {
        case 'price-ascending':
          return (parseInt(cardA.getAttribute('data-product-price')) || 0) - 
                 (parseInt(cardB.getAttribute('data-product-price')) || 0);
        case 'price-descending':
          return (parseInt(cardB.getAttribute('data-product-price')) || 0) - 
                 (parseInt(cardA.getAttribute('data-product-price')) || 0);
        case 'created-descending':
          return new Date(cardB.getAttribute('data-product-created') || '1970-01-01') - 
                 new Date(cardA.getAttribute('data-product-created') || '1970-01-01');
        default:
          return 0;
      }
    });
    
    // Disconnect MutationObserver before DOM manipulation
    if (state.mutationObserver) {
      state.mutationObserver.disconnect();
    }
    
    items.forEach(function(item) {
      grid.appendChild(item);
    });
    
    // Reconnect after delay
    setTimeout(function() {
      setupMutationObserver();
    }, 200);
  }

  // ==================== UPDATE PROGRESS BAR ====================
  function updateProgressBar(panel, visibleCount) {
    var progressText = panel.querySelector('.progress-text');
    var progressBar = panel.querySelector('.progress-bar-fill');
    
    if (progressText && state.filtersApplied) {
      progressText.innerHTML = '1 - ' + visibleCount + ' of <span id="ProductCountDesktop">' + visibleCount + '</span> results (filtered)';
    }
    
    if (progressBar && state.filtersApplied) {
      progressBar.style.width = '100%';
    }
  }

  // ==================== HANDLE NO RESULTS ====================
  function handleNoResults(panel, visibleCount) {
    var existingMessage = panel.querySelector('.no-results-message');
    
    if (visibleCount === 0 && state.filtersApplied) {
      if (!existingMessage) {
        var message = document.createElement('div');
        message.className = 'no-results-message';
        message.innerHTML = '<p>No products match your selected filters.</p><button type="button" class="no-results-reset">Clear Filters</button>';
        
        var grid = panel.querySelector('#product-grid, .product-grid');
        if (grid && grid.parentNode) {
          grid.parentNode.insertBefore(message, grid.nextSibling);
        }
        
        message.querySelector('.no-results-reset').addEventListener('click', function() {
          resetFilters();
        });
      }
    } else if (existingMessage) {
      existingMessage.remove();
    }
  }

  // ==================== ACTIVE FILTERS DISPLAY ====================
  function updateActiveFiltersDisplay() {
    var filtersContainer = document.querySelector('#selected-filters-js .filters-list');
    var sortContainer = document.querySelector('#selected-filters-js .sort-list');
    var parentContainer = document.getElementById('selected-filters-js');
    
    if (!filtersContainer) return;
    
    var hasFilters = Object.keys(FILTER_CONFIG.filters).some(function(filterType) {
      return state.activeFilters[filterType].length > 0;
    });
    var hasSort = state.activeFilters.sort && state.activeFilters.sort !== 'manual';
    
    filtersContainer.innerHTML = '';
    if (sortContainer) sortContainer.innerHTML = '';
    
    if (!hasFilters && !hasSort) {
      if (parentContainer) parentContainer.style.display = 'none';
      return;
    }
    
    if (parentContainer) parentContainer.style.display = 'flex';
    
    var filtersHtml = '';
    Object.keys(FILTER_CONFIG.filters).forEach(function(filterType) {
      state.activeFilters[filterType].forEach(function(value) {
        var filter = state.availableFilters[filterType].find(function(f) { return f.value === value; });
        var label = filter ? filter.label : formatLabel(value);
        
        filtersHtml += '<li class="redemption-active-filter" data-filter-type="' + filterType + '" data-filter-value="' + value + '">' +
          '<span class="redemption-active-filter__label">' + label + '</span>' +
          '<button type="button" class="redemption-active-filter__remove" aria-label="Remove filter">' +
          '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="9.54592" y="3.18213" width="1" height="9" transform="rotate(45 9.54592 3.18213)" fill="#061096"/><rect x="3.88918" y="3.18213" width="9" height="1" transform="rotate(45 3.88918 3.18213)" fill="#061096"/></svg>' +
          '</button>' +
          '</li>';
      });
    });
    
    filtersContainer.innerHTML = filtersHtml;
    
    if (hasSort && sortContainer) {
      var sortOption = FILTER_CONFIG.sortOptions.find(function(opt) { return opt.value === state.activeFilters.sort; });
      var sortLabel = sortOption ? sortOption.label : state.activeFilters.sort;
      
      sortContainer.innerHTML = '<li class="redemption-active-filter redemption-active-sort" data-sort-value="' + state.activeFilters.sort + '">' +
        '<span class="redemption-active-filter__label">Sort: ' + sortLabel + '</span>' +
        '<button type="button" class="redemption-active-filter__remove" aria-label="Remove sort">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="9.54592" y="3.18213" width="1" height="9" transform="rotate(45 9.54592 3.18213)" fill="#061096"/><rect x="3.88918" y="3.18213" width="9" height="1" transform="rotate(45 3.88918 3.18213)" fill="#061096"/></svg>' +
        '</button>' +
        '</li>';
    }
    
    filtersContainer.querySelectorAll('.redemption-active-filter__remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var filterItem = btn.closest('.redemption-active-filter');
        var filterType = filterItem.getAttribute('data-filter-type');
        var filterValue = filterItem.getAttribute('data-filter-value');
        
        var index = state.activeFilters[filterType].indexOf(filterValue);
        if (index > -1) {
          state.activeFilters[filterType].splice(index, 1);
        }
        
        renderFilters();
        applyFilters();
      });
    });
    
    if (sortContainer) {
      var sortRemoveBtn = sortContainer.querySelector('.redemption-active-filter__remove');
      if (sortRemoveBtn) {
        sortRemoveBtn.addEventListener('click', function() {
          state.activeFilters.sort = 'manual';
          var sortRadio = elements.panel.querySelector('input[name="redemption-sort"][value="manual"]');
          if (sortRadio) sortRadio.checked = true;
          applyFilters();
        });
      }
    }
    // Update mobile filter button state
    updateMobileFilterButton();
  }

  // ==================== UPDATE MOBILE FILTER BUTTON ====================
  function updateMobileFilterButton() {
    var filterCover = document.getElementById('filter-cover');
    var filterCountBadge = document.getElementById('filter-count-badge');
    
    if (!filterCover) return;
    
    // Count total active filters (excluding sort)
    var totalFilters = 0;
    Object.keys(FILTER_CONFIG.filters).forEach(function(filterType) {
      totalFilters += state.activeFilters[filterType].length;
    });
    
    if (totalFilters > 0) {
      filterCover.classList.add('has-filters');
      if (filterCountBadge) {
        filterCountBadge.textContent = totalFilters;
      }
    } else {
      filterCover.classList.remove('has-filters');
      if (filterCountBadge) {
        filterCountBadge.textContent = '';
      }
    }
  }
  
  // ==================== REFRESH FILTERS ====================
  function refreshFilters() {
    console.log('[RedemptionFilters] refreshFilters called, filtersApplied=' + state.filtersApplied);
    
    buildFiltersFromCurrentTab();
    
    if (state.filtersApplied) {
      requestAnimationFrame(function() {
        console.log('[RedemptionFilters] Re-applying filters after load more');
        applyClientSideFilters();
        applyVideoVisibility();
        reorganizeGrid();
        fixGridBorders();
      });
    }
  }

  // ==================== INIT ====================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose API
  window.RedemptionFilters = {
    open: openPanel,
    close: closePanel,
    reset: resetFilters,
    apply: applyFilters,
    getState: function() { return state; },
    rebuild: buildFiltersFromCurrentTab,
    refreshFilters: refreshFilters,
    reapplyFilters: function() {
      applyClientSideFilters();
      applyVideoVisibility();
      reorganizeGrid();
      fixGridBorders();
    },
    isFiltersApplied: function() { return state.filtersApplied; },
    filterNewProduct: function(gridItem) {
      if (!state.filtersApplied) return;
      
      if (gridItem.classList.contains('video-item')) {
        return;
      }
      
      var card = gridItem.querySelector('.card-wrapper, .product-card-wrapper') || gridItem;
      var shouldShow = productMatchesFilters(card);
      
      if (!shouldShow) {
        gridItem.style.setProperty('display', 'none', 'important');
        gridItem.classList.add('filtered-hidden');
      }
    }
  };

})();
